{
  "AUDIT_LOGS": {
    "HEADER": "Jurnale de audit",
    "HEADER_BTN_TXT": "Adăugarea jurnalelor de audit",
    "LOADING": "Preluarea jurnalelor de audit",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Nu există elemente care să corespundă acestei interogări",
    "SIDEBAR_TXT": "<p><b>Jurnale de audit</b> </p><p> Jurnalele de audit sunt piste pentru evenimente și acțiuni într-un sistem Chatwoot. </p>",
    "LIST": {
      "404": "Nu există jurnale de audit disponibile în acest cont.",
      "TITLE": "Gestionarea jurnalelor de audit",
      "DESC": "Jurnalele de audit sunt piste pentru evenimente și acțiuni într-un sistem Chatwoot.",
      "TABLE_HEADER": {
        "ACTIVITY": "Activitate",
        "TIME": "Timp",
        "IP_ADDRESS": "Adresă IP"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "AuditLogs preluat cu succes",
      "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
    },
    "DEFAULT_USER": "Sistem",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} invited {invitee} to the account as an {role}",
      "EDIT": {
        "SELF": "{agentName} changed their {attributes} to {values}",
        "OTHER": "{agentName} changed {attributes} of {user} to {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} s-a autentificat",
      "SIGN_OUT": "{agentName} s-a deconectat"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "DELETE": "{agentName} deleted conversation #{id}"
    }
  }
}
